import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';

export function PrimisVideo({ src }) {
  const primisRef = useRef();

  useEffect(() => {
    if (get(primisRef, 'current')) {
      const script = document.createElement('script');
      const primisTestDiv = primisRef.current;
      script.type = 'text/javascript';
      script.src = src;
      script.async = true; // Optional: set to false if the script needs to be loaded synchronously
      primisTestDiv.appendChild(script);

      // Cleanup function to remove the script when the component unmounts
      return () => {
        primisTestDiv.removeChild(script);
      };
    }
    return undefined;
  }, [src]); // Empty dependency array ensures this runs only once after initial render
  return (
    <FeatureFlag name="enablePrimis">
      <div ref={primisRef} className="heading-4 pb-1">
        <span className="pb-0_5 d-block">Testing Primis</span>
      </div>
    </FeatureFlag>
  );
}

PrimisVideo.propTypes = {
  src: PropTypes.string.isRequired,
};
